import { IItemCustomization } from "@faire/web-api--source/indigofair/data/IItemCustomization";
import React from "react";

export enum QuickAddModalEvent {
  GO_TO_PRODUCT_PAGE,
  CHANGE_QUANTITY,
  ADD_TO_CART,
}

export type QuickAddModalEventHandler = (
  event: QuickAddModalEvent,
  token: string | undefined,
  hasOptions?: boolean,
  quantities?: { oldValue: number; newValue: number }
) => void;

export interface IQuickAddModalContextData {
  onViewProductDetailsClick?: () => void;
  onEvent?: QuickAddModalEventHandler;
  defaults?: {
    quantity?: number;
    optionToken?: string;
    customizations?: IItemCustomization[];
  };
  cartItemToken?: string;
  updateOnChange?: boolean;
}

export const QuickAddModalContext =
  React.createContext<IQuickAddModalContextData>({});
